import { useState, FormEvent } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

export default function Login() {
  const { isAuthenticated, isLoading, login, loginPending, loginError } = useAuth();
  const [password, setPassword] = useState('');

  if (!isLoading && isAuthenticated) return <Navigate to="/upload" replace />;

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    try {
      await login(password);
    } catch {}
  }

  return (
    <div className="min-h-screen grid place-items-center p-4">
      <form onSubmit={handleSubmit} className="w-full max-w-sm bg-mbc-panel border border-mbc-line rounded-2xl p-8 shadow-2xl">
        <div className="text-center mb-6">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-mbc-orange text-white font-extrabold text-2xl">M</div>
          <h1 className="mt-3 text-white font-extrabold text-xl">MBC Supply</h1>
          <p className="text-xs text-mbc-mute">Compras Inteligentes</p>
        </div>
        <label className="block text-xs text-mbc-mute font-semibold uppercase mb-1">Senha de acesso</label>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoFocus
          required
          className="w-full bg-mbc-panel2 border border-mbc-line rounded-lg px-3 py-3 text-white text-lg"
        />
        {loginError && (
          <p className="mt-2 text-sm text-rose-300">Senha incorreta. Tente novamente.</p>
        )}
        <button
          type="submit"
          disabled={loginPending || !password}
          className="mt-4 w-full bg-mbc-orange hover:bg-mbc-orangel disabled:opacity-50 text-white font-bold py-3 rounded-xl"
        >
          {loginPending ? 'Entrando…' : 'Entrar'}
        </button>
      </form>
    </div>
  );
}
